// // // import React, { useState, useEffect } from 'react';
// // // import { Menu, X, Phone, Mail, MapPin, Clock, Send, ArrowRight, Instagram, Twitter, Facebook, Linkedin } from 'lucide-react';

// // // const ContactPage = () => {
// // //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// // //   const [scrollY, setScrollY] = useState(0);
// // //   const [formData, setFormData] = useState({
// // //     name: '',
// // //     email: '',
// // //     phone: '',
// // //     service: '',
// // //     message: ''
// // //   });

// // //   useEffect(() => {
// // //     const handleScroll = () => setScrollY(window.scrollY);
// // //     window.addEventListener('scroll', handleScroll);
// // //     return () => window.removeEventListener('scroll', handleScroll);
// // //   }, []);

// // //   const handleInputChange = (e) => {
// // //     setFormData({
// // //       ...formData,
// // //       [e.target.name]: e.target.value
// // //     });
// // //   };

// // //   const handleSubmit = (e) => {
// // //     e.preventDefault();
// // //     // Handle form submission
// // //     console.log('Form submitted:', formData);
// // //   };

// // //   const contactInfo = [
// // //     {
// // //       icon: <Phone className="w-6 h-6" />,
// // //       title: "Phone",
// // //       details: ["+1 (555) 123-4567", "+1 (555) 987-6543"],
// // //       action: "Call us today"
// // //     },
// // //     {
// // //       icon: <Mail className="w-6 h-6" />,
// // //       title: "Email",
// // //       details: ["hello@luxeinteriors.com", "projects@luxeinteriors.com"],
// // //       action: "Send us a message"
// // //     },
// // //     {
// // //       icon: <MapPin className="w-6 h-6" />,
// // //       title: "Studio",
// // //       details: ["123 Design Avenue", "New York, NY 10001"],
// // //       action: "Visit our showroom"
// // //     },
// // //     {
// // //       icon: <Clock className="w-6 h-6" />,
// // //       title: "Hours",
// // //       details: ["Mon - Fri: 9AM - 6PM", "Sat: 10AM - 4PM"],
// // //       action: "Schedule appointment"
// // //     }
// // //   ];

// // //   return (
// // //     <div className="min-h-screen bg-stone-50 text-stone-800">
// // //       {/* Load Fonts */}
// // //       <link
// // //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// // //         rel="stylesheet"
// // //       />

// // //       {/* Navigation */}
// // //       <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${
// // //         scrollY > 50 ? 'bg-stone-50/95 backdrop-blur-md shadow-lg' : 'bg-stone-50/80 backdrop-blur-sm'
// // //       }`}>
// // //         <div className="max-w-7xl mx-auto px-6 py-4">
// // //           <div className="flex items-center justify-between">
// // //             <div className="text-2xl font-bold font-serif" style={{fontFamily: "'Playfair Display', serif"}}>
// // //               LUXE INTERIORS
// // //             </div>
            
// // //             {/* Desktop Menu */}
// // //             <div className="hidden md:flex items-center space-x-8">
// // //               <a href="#home" className="text-stone-600 hover:text-stone-900 transition-colors font-medium">Home</a>
// // //               <a href="#services" className="text-stone-600 hover:text-stone-900 transition-colors font-medium">Services</a>
// // //               <a href="#portfolio" className="text-stone-600 hover:text-stone-900 transition-colors font-medium">Portfolio</a>
// // //               <a href="#about" className="text-stone-600 hover:text-stone-900 transition-colors font-medium">About</a>
// // //               <a href="#contact" className="text-stone-900 font-semibold">Contact</a>
// // //             </div>

// // //             {/* Mobile Menu Button */}
// // //             <button 
// // //               onClick={() => setIsMenuOpen(!isMenuOpen)}
// // //               className="md:hidden"
// // //             >
// // //               {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
// // //             </button>
// // //           </div>

// // //           {/* Mobile Menu */}
// // //           <div className={`md:hidden transition-all duration-300 overflow-hidden ${
// // //             isMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
// // //           }`}>
// // //             <div className="pt-4 pb-2 space-y-2">
// // //               <a href="#home" className="block py-2 text-stone-600 hover:text-stone-900">Home</a>
// // //               <a href="#services" className="block py-2 text-stone-600 hover:text-stone-900">Services</a>
// // //               <a href="#portfolio" className="block py-2 text-stone-600 hover:text-stone-900">Portfolio</a>
// // //               <a href="#about" className="block py-2 text-stone-600 hover:text-stone-900">About</a>
// // //               <a href="#contact" className="block py-2 text-stone-900 font-semibold">Contact</a>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </nav>

// // // {/* Hero Section - Matching Screenshot */}
// // // <section className="bg-[#f5f1eb] py-24 relative">
// // //   <div className="max-w-7xl mx-auto px-6">
// // //     <div className="grid lg:grid-cols-2 gap-16 items-center">
// // //       {/* Left Content */}
// // //       <div className="flex flex-col justify-center h-full -mt-12">
// // //         <h1
// // //           className="text-5xl md:text-6xl font-light text-stone-800 mb-8 leading-tight"
// // //           style={{ fontFamily: "'Playfair Display', serif" }}
// // //         >
// // //           ARE YOU READY FOR
// // //           <br />
// // //           YOUR NEW SPACE?
// // //         </h1>

// // //         <a
// // //           href="#contact"
// // //           className="inline-block text-lg font-medium tracking-wide text-stone-800 uppercase border-b border-stone-800 hover:text-stone-600 transition-colors"
// // //         >
// // //           Contact Us
// // //         </a>
// // //       </div>

// // //       {/* Right Images */}
// // //       <div className="relative">
// // //         {/* Main large image */}
// // //         <div className="relative z-10">
// // //           <img
// // //             src="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=800&h=600&fit=crop"
// // //             alt="Modern Kitchen Design"
// // //             className="w-[550px] h-[420px] object-cover"
// // //           />
// // //         </div>

// // //         {/* Overlapping smaller image */}
// // //         <div className="absolute -bottom-20 -left-20 z-20 shadow-xl">
// // //           <img
// // //             src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop"
// // //             alt="Dining Area Design"
// // //             className="w-[380px] h-[260px] object-cover"
// // //           />
// // //         </div>
// // //       </div>
// // //     </div>
// // //   </div>
// // // </section>



// // //       {/* Contact Information Section */}
// // //       <section className="py-20 bg-stone-50">
// // //         <div className="max-w-7xl mx-auto px-6">
// // //           <div className="text-center mb-16">
// // //             <h2 
// // //               className="text-5xl font-bold text-stone-900 mb-6"
// // //               style={{fontFamily: "'Playfair Display', serif"}}
// // //             >
// // //               Get In Touch
// // //             </h2>
// // //             <p className="text-xl text-stone-600 max-w-3xl mx-auto">
// // //               Multiple ways to reach us for your convenience. We're here to help bring your vision to life.
// // //             </p>
// // //           </div>

// // //           <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
// // //             {contactInfo.map((info, index) => (
// // //               <div
// // //                 key={index}
// // //                 className="text-center group hover:transform hover:scale-105 transition-all duration-500"
// // //               >
// // //                 <div className="bg-stone-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:bg-stone-900 transition-colors duration-500">
// // //                   <div className="text-stone-900 group-hover:text-stone-50 transition-colors duration-500">
// // //                     {info.icon}
// // //                   </div>
// // //                 </div>
// // //                 <h3 className="text-xl font-bold text-stone-900 mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
// // //                   {info.title}
// // //                 </h3>
// // //                 <div className="space-y-2 mb-4">
// // //                   {info.details.map((detail, idx) => (
// // //                     <p key={idx} className="text-stone-600">{detail}</p>
// // //                   ))}
// // //                 </div>
// // //                 <p className="text-stone-500 text-sm font-medium">{info.action}</p>
// // //               </div>
// // //             ))}
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Contact Form Section */}
// // //       <section className="py-20 bg-stone-100">
// // //         <div className="max-w-4xl mx-auto px-6">
// // //           <div className="text-center mb-16">
// // //             <h2 
// // //               className="text-5xl font-bold text-stone-900 mb-6"
// // //               style={{fontFamily: "'Playfair Display', serif"}}
// // //             >
// // //               Start Your Project
// // //             </h2>
// // //             <p className="text-xl text-stone-600">
// // //               Tell us about your project and we'll get back to you within 24 hours.
// // //             </p>
// // //           </div>

// // //           <div className="space-y-8">
// // //             <div className="grid md:grid-cols-2 gap-8">
// // //               <div>
// // //                 <label className="block text-stone-700 font-semibold mb-3">Full Name *</label>
// // //                 <input
// // //                   type="text"
// // //                   name="name"
// // //                   value={formData.name}
// // //                   onChange={handleInputChange}
// // //                   required
// // //                   className="w-full px-6 py-4 bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-transparent transition-all duration-300"
// // //                   placeholder="Your full name"
// // //                 />
// // //               </div>
// // //               <div>
// // //                 <label className="block text-stone-700 font-semibold mb-3">Email Address *</label>
// // //                 <input
// // //                   type="email"
// // //                   name="email"
// // //                   value={formData.email}
// // //                   onChange={handleInputChange}
// // //                   required
// // //                   className="w-full px-6 py-4 bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-transparent transition-all duration-300"
// // //                   placeholder="your@email.com"
// // //                 />
// // //               </div>
// // //             </div>

// // //             <div className="grid md:grid-cols-2 gap-8">
// // //               <div>
// // //                 <label className="block text-stone-700 font-semibold mb-3">Phone Number</label>
// // //                 <input
// // //                   type="tel"
// // //                   name="phone"
// // //                   value={formData.phone}
// // //                   onChange={handleInputChange}
// // //                   className="w-full px-6 py-4 bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-transparent transition-all duration-300"
// // //                   placeholder="(555) 123-4567"
// // //                 />
// // //               </div>
// // //               <div>
// // //                 <label className="block text-stone-700 font-semibold mb-3">Service Interested In</label>
// // //                 <select
// // //                   name="service"
// // //                   value={formData.service}
// // //                   onChange={handleInputChange}
// // //                   className="w-full px-6 py-4 bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-transparent transition-all duration-300"
// // //                 >
// // //                   <option value="">Select a service</option>
// // //                   <option value="residential">Residential Design</option>
// // //                   <option value="commercial">Commercial Design</option>
// // //                   <option value="consultation">Design Consultation</option>
// // //                   <option value="renovation">Full Renovation</option>
// // //                   <option value="styling">Interior Styling</option>
// // //                 </select>
// // //               </div>
// // //             </div>

// // //             <div>
// // //               <label className="block text-stone-700 font-semibold mb-3">Tell us about your project *</label>
// // //               <textarea
// // //                 name="message"
// // //                 value={formData.message}
// // //                 onChange={handleInputChange}
// // //                 required
// // //                 rows={6}
// // //                 className="w-full px-6 py-4 bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-stone-400 focus:border-transparent transition-all duration-300 resize-none"
// // //                 placeholder="Describe your vision, space, timeline, and any specific requirements..."
// // //               ></textarea>
// // //             </div>

// // //             <div className="text-center">
// // //               <button
// // //                 type="submit"
// // //                 className="group bg-stone-900 text-stone-50 px-12 py-4 rounded-full hover:bg-stone-800 transition-all duration-300 transform hover:scale-105 font-semibold text-lg"
// // //               >
// // //                 <span className="flex items-center gap-2">
// // //                   Send Message
// // //                   <Send className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
// // //                 </span>
// // //               </button>
// // //               <p className="text-stone-500 text-sm mt-4">
// // //                 We'll respond within 24 hours to discuss your project.
// // //               </p>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       </section>

// // //       {/* Map Section */}
// // //     {/* Visit Our Offices Section */}
// // // <section className="py-20 bg-[#f5f1eb]">
// // //   <div className="max-w-7xl mx-auto px-6">
// // //     {/* Header */}
// // //     <div className="text-center mb-16">
// // //       <h2
// // //         className="text-5xl md:text-6xl font-light text-stone-800 mb-6 tracking-wider"
// // //         style={{ fontFamily: "'Playfair Display', serif" }}
// // //       >
// // //         VISIT OUR OFFICE
// // //       </h2>
// // //       <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
// // //         Tortor accumsan nec dolor, penatibus accumsan ridiculus hac lorem elementum nibh
// // //         facilisis malesuada facilisis feugiat.
// // //       </p>
// // //     </div>

// // //     {/* Image with Floating Card */}
// // //     <div className="relative">
// // //       {/* Background Image */}
// // //       <img
// // //         src="https://cdn.prod.website-files.com/66ec399f6b28eb713c5695e8/66f43197a22bf84004241060_our-office-image-decor-x-webflow-template.jpg"
// // //         alt="Modern Office Workspace"
// // //         className="w-full h-[600px] object-cover"
// // //       />

// // //       {/* Floating Office Info Card */}
// // //       <div className="absolute top-12 left-12 bg-white p-10 shadow-xl max-w-sm">
// // //         <h3
// // //           className="text-3xl font-light text-stone-900 mb-10 tracking-wider"
// // //           style={{ fontFamily: "'Playfair Display', serif" }}
// // //         >
// // //           OFFICE
// // //         </h3>

// // //         <div className="space-y-10">
// // //           {/* New York Office */}
// // //           <div>
// // //             <h4
// // //               className="text-xl font-medium text-stone-900 mb-3 tracking-wide"
// // //               style={{ fontFamily: "'Playfair Display', serif" }}
// // //             >
// // //               Hyderabad
// // //             </h4>
// // //             <p className="text-stone-600 leading-relaxed">
// // //               24 East Market Ave, Jamaica, <br />
// // //               Hyderabad 11435
// // //             </p>
// // //           </div>

// // //           {/* Los Angeles Office */}
// // //           {/* <div>
// // //             <h4
// // //               className="text-xl font-medium text-stone-900 mb-3 tracking-wide"
// // //               style={{ fontFamily: "'Playfair Display', serif" }}
// // //             >
// // //               LOS ANGELES
// // //             </h4>
// // //             <p className="text-stone-600 leading-relaxed">
// // //               672 Tailwater Lane Massapequa, <br />
// // //               Los Angeles 11758
// // //             </p>
// // //           </div> */}
// // //         </div>
// // //       </div>
// // //     </div>
// // //   </div>
// // // </section>


// // //       {/* Social Media Section */}
// // // {/* Follow Our Journey */}
// // // <section className="py-20 bg-[#f5f1eb]">
// // //   <div className="max-w-4xl mx-auto px-6 text-center">
// // //     <h2
// // //       className="text-4xl font-light text-stone-800 mb-6 tracking-wider"
// // //       style={{ fontFamily: "'Playfair Display', serif" }}
// // //     >
// // //       Follow Our Journey
// // //     </h2>
// // //     <p className="text-stone-600 mb-12 text-lg leading-relaxed">
// // //       Stay inspired with our latest projects and design insights.
// // //     </p>

// // //     <div className="flex justify-center space-x-8">
// // //       {[
// // //         { icon: <Instagram className="w-6 h-6" />, name: "Instagram" },
// // //         { icon: <Facebook className="w-6 h-6" />, name: "Facebook" },
// // //         { icon: <Twitter className="w-6 h-6" />, name: "Twitter" },
// // //         { icon: <Linkedin className="w-6 h-6" />, name: "LinkedIn" }
// // //       ].map((social, index) => (
// // //         <a
// // //           key={index}
// // //           href="#"
// // //           className="text-stone-700 hover:text-stone-900 transition-colors duration-300"
// // //           aria-label={social.name}
// // //         >
// // //           {social.icon}
// // //         </a>
// // //       ))}
// // //     </div>
// // //   </div>
// // // </section>

// // // {/* Footer */}
// // // <footer className="bg-[#f5f1eb] text-stone-800 py-16 border-t border-stone-300">
// // //   <div className="max-w-7xl mx-auto px-6 text-center">
// // //     <div
// // //       className="text-3xl font-light mb-6 tracking-wider"
// // //       style={{ fontFamily: "'Playfair Display', serif" }}
// // //     >
// // //       LUXE INTERIORS
// // //     </div>
// // //     <p className="text-stone-600 mb-8 text-lg">
// // //       Crafting extraordinary spaces since 2008
// // //     </p>
// // //     <div className="text-stone-500 text-sm">
// // //       © 2024 Luxe Interiors. All rights reserved.
// // //     </div>
// // //   </div>
// // // </footer>

// // //     </div>
// // //   );
// // // };

// // // export default ContactPage;



// // import React, { useState, useEffect } from 'react';
// // import { Menu, X, Phone, Mail, MapPin, Clock, Send, ArrowRight, Instagram, Twitter, Facebook, Linkedin } from 'lucide-react';

// // const ContactPage = () => {
// //   const [isMenuOpen, setIsMenuOpen] = useState(false);
// //   const [scrollY, setScrollY] = useState(0);
// //   const [isVisible, setIsVisible] = useState({});
// //   const [formData, setFormData] = useState({
// //     name: '',
// //     email: '',
// //     phone: '',
// //     service: '',
// //     message: ''
// //   });

// //   // Scroll handler for navbar background
// //   useEffect(() => {
// //     const handleScroll = () => setScrollY(window.scrollY);
// //     window.addEventListener('scroll', handleScroll);
// //     return () => window.removeEventListener('scroll', handleScroll);
// //   }, []);

// //   // Intersection Observer for scroll animations
// //   useEffect(() => {
// //     const observer = new IntersectionObserver(
// //       (entries) => {
// //         entries.forEach((entry) => {
// //           if (entry.isIntersecting) {
// //             setIsVisible(prev => ({
// //               ...prev,
// //               [entry.target.id]: true
// //             }));
// //           }
// //         });
// //       },
// //       { 
// //         threshold: 0.1,
// //         rootMargin: '0px 0px -50px 0px'
// //       }
// //     );

// //     const elements = document.querySelectorAll('[data-animate]');
// //     elements.forEach((el) => observer.observe(el));

// //     return () => observer.disconnect();
// //   }, []);

// //   const handleInputChange = (e) => {
// //     setFormData({
// //       ...formData,
// //       [e.target.name]: e.target.value
// //     });
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     // Handle form submission
// //     console.log('Form submitted:', formData);
// //   };

// //   const contactInfo = [
// //     {
// //       icon: <Phone className="w-5 h-5 md:w-6 md:h-6" />,
// //       title: "Phone",
// //       details: ["+91 95735 78899"],
// //       action: "Call us today"
// //     },
// //     {
// //       icon: <Mail className="w-5 h-5 md:w-6 md:h-6" />,
// //       title: "Email",
// //       details: ["support@constructinsides.com"],
// //       action: "Send us a message"
// //     },
// //     {
// //       icon: <MapPin className="w-5 h-5 md:w-6 md:h-6" />,
// //       title: "Studio",
// //       details: ["Mathrusree Nagar,", "Miyapur","HYDERABAD"],
// //       action: "Visit our office"
// //     },
// //     {
// //       icon: <Clock className="w-5 h-5 md:w-6 md:h-6" />,
// //       title: "Hours",
// //       details: ["Mon - Sat: 9AM - 7PM", "Sun: 10AM - 6PM"],
// //       action: "Schedule appointment"
// //     }
// //   ];

// //   return (
// //     <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
// //       {/* Load Fonts */}
// //       <link
// //         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
// //         rel="stylesheet"
// //       />

// //       {/* Navigation */}
     

// //       {/* Hero Section */}
// //       <section className="bg-[#f5f1eb] py-16 sm:py-20 md:py-24 lg:py-32 relative mt-16 sm:mt-20">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
// //             {/* Left Content */}
// //             <div data-animate id="hero-content">
// //               <div className={`flex flex-col justify-center h-full transition-all duration-1000 ${isVisible['hero-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //                 <h1
// //                   className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-stone-800 mb-6 md:mb-8 leading-tight"
// //                   style={{ fontFamily: "'Playfair Display', serif" }}
// //                 >
// //                   ARE YOU READY FOR
// //                   <br />
// //                   YOUR NEW SPACE?
// //                 </h1>

// //                 <a
// //                   href="#contact"
// //                   className="inline-block text-base sm:text-lg font-medium tracking-wide text-stone-800 uppercase border-b border-stone-800 hover:text-stone-600 transition-colors w-fit"
// //                 >
// //                   Contact Us
// //                 </a>
// //               </div>
// //             </div>

// //             {/* Right Images */}
// //             <div data-animate id="hero-images">
// //               <div className={`relative transition-all duration-1000 delay-300 ${isVisible['hero-images'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
// //                 {/* Main large image */}
// //                 <div className="relative z-10">
// //                   <img
// //                     src="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=800&h=600&fit=crop"
// //                     alt="Modern Kitchen Design"
// //                     className="w-full max-w-[550px] h-[300px] sm:h-[350px] md:h-[420px] object-cover mx-auto lg:mx-0"
// //                   />
// //                 </div>

// //                 {/* Overlapping smaller image */}
// //                 <div className="absolute -bottom-10 sm:-bottom-16 md:-bottom-20 -left-4 sm:-left-8 md:-left-20 z-20 shadow-xl">
// //                   <img
// //                     src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&h=400&fit=crop"
// //                     alt="Dining Area Design"
// //                     className="w-[280px] sm:w-[320px] md:w-[380px] h-[180px] sm:h-[220px] md:h-[260px] object-cover"
// //                   />
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Contact Information Section */}
// //       <section className="py-16 md:py-20 bg-stone-50">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div data-animate id="contact-info-title">
// //             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['contact-info-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               <h2 
// //                 className="text-3xl sm:text-4xl md:text-5xl font-bold text-stone-900 mb-4 md:mb-6"
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 Get In Touch
// //               </h2>
// //               <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto px-4">
// //                 Multiple ways to reach us for your convenience. We're here to help bring your vision to life.
// //               </p>
// //             </div>
// //           </div>

// //           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
// //             {contactInfo.map((info, index) => (
// //               <div key={index} data-animate id={`contact-card-${index}`}>
// //                 <div
// //                   className={`text-center group hover:transform hover:scale-105 transition-all duration-500 ${isVisible[`contact-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //                   style={{ transitionDelay: `${index * 100}ms` }}
// //                 >
// //                   <div className="bg-stone-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:bg-stone-200 transition-all duration-500">
// //                     <div className="text-stone-700 group-hover:text-stone-900 transition-colors duration-500">
// //                       {info.icon}
// //                     </div>
// //                   </div>
// //                   <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-3 md:mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
// //                     {info.title}
// //                   </h3>
// //                   <div className="space-y-1 md:space-y-2 mb-3 md:mb-4">
// //                     {info.details.map((detail, idx) => (
// //                       <p key={idx} className="text-sm md:text-base text-stone-600">{detail}</p>
// //                     ))}
// //                   </div>
// //                   <p className="text-xs md:text-sm text-stone-500 font-medium">{info.action}</p>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </section>

// //       {/* Contact Form Section */}
// //       <section className="py-16 md:py-20 bg-[#f5f1eb]" id="contact">
// //         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
// //           <div data-animate id="form-title">
// //             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['form-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               <h2 
// //                 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-stone-800 mb-4 md:mb-6 tracking-widest"
// //                 style={{fontFamily: "'Playfair Display', serif"}}
// //               >
// //                 START YOUR PROJECT
// //               </h2>
// //               <p className="text-base md:text-lg text-stone-600 px-4 max-w-lg mx-auto leading-relaxed">
// //                 Turn your vision into reality—start creating your dream interiors today
// //               </p>
// //             </div>
// //           </div>

// //           <div data-animate id="contact-form">
// //             <div 
// //               className={`space-y-6 md:space-y-8 transition-all duration-1000 delay-300 ${isVisible['contact-form'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
// //             >
// //               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
// //                 <div>
// //                   <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
// //                     Full Name*
// //                   </label>
// //                   <input
// //                     type="text"
// //                     name="name"
// //                     value={formData.name}
// //                     onChange={handleInputChange}
// //                     required
// //                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
// //                     placeholder="JOHN CARTER"
// //                   />
// //                 </div>
// //                 <div>
// //                   <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
// //                     Phone Number*
// //                   </label>
// //                   <input
// //                     type="tel"
// //                     name="phone"
// //                     value={formData.phone}
// //                     onChange={handleInputChange}
// //                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
// //                     placeholder=""
// //                   />
// //                 </div>
// //               </div>

// //               <div>
// //                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
// //                   Email*
// //                 </label>
// //                 <input
// //                   type="email"
// //                   name="email"
// //                   value={formData.email}
// //                   onChange={handleInputChange}
// //                   required
// //                   className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
// //                   placeholder="EXAMPLE@EMAIL.COM"
// //                 />
// //               </div>

// //               <div>
// //                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
// //                   Service*
// //                 </label>
// //                 <div className="relative">
// //                   <select
// //                     name="service"
// //                     value={formData.service}
// //                     onChange={handleInputChange}
// //                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 appearance-none cursor-pointer"
// //                   >
// //                     <option value="">EX. SPACE PLANNING</option>
// //                     <option value="residential">RESIDENTIAL DESIGN</option>
// //                     <option value="commercial">COMMERCIAL DESIGN</option>
// //                     <option value="consultation">DESIGN CONSULTATION</option>
// //                     <option value="renovation">FULL RENOVATION</option>
// //                     <option value="styling">INTERIOR STYLING</option>
// //                   </select>
// //                   <div className="absolute right-0 top-1/2 transform -translate-y-1/2 pointer-events-none">
// //                     <svg className="w-4 h-4 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
// //                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
// //                     </svg>
// //                   </div>
// //                 </div>
// //               </div>

// //               <div>
// //                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
// //                   Message
// //                 </label>
// //                 <textarea
// //                   name="message"
// //                   value={formData.message}
// //                   onChange={handleInputChange}
// //                   rows={5}
// //                   className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 resize-none text-sm md:text-base text-stone-600 placeholder-stone-400"
// //                   placeholder="WRITE YOUR MESSAGE"
// //                 ></textarea>
// //               </div>

// //               <div className="pt-6">
// //                 <div className="flex items-start space-x-3 mb-6">
// //                   <input
// //                     type="checkbox"
// //                     id="privacy"
// //                     className="mt-1 w-4 h-4 border border-stone-400 rounded-sm"
// //                   />
// //                   <label htmlFor="privacy" className="text-xs md:text-sm text-stone-600 leading-relaxed">
// //                     By checking this box, you agree that your information is protected under our{' '}
// //                     <span className="underline cursor-pointer">Privacy Policy</span> and our{' '}
// //                     <span className="underline cursor-pointer">Terms and Conditions</span>.
// //                   </label>
// //                 </div>

// //                 <button
// //                   onClick={handleSubmit}
// //                   className="bg-stone-900 text-stone-50 px-8 md:px-12 py-3 md:py-4 hover:bg-stone-800 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase"
// //                   style={{fontFamily: "'Playfair Display', serif"}}
// //                 >
// //                   Send Message
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Visit Our Office Section */}
// //       <section className="py-16 md:py-20 bg-[#f5f1eb]">
// //         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //           {/* Header */}
// //           <div data-animate id="office-title">
// //             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['office-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //               <h2
// //                 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
// //                 style={{ fontFamily: "'Playfair Display', serif" }}
// //               >
// //                 VISIT OUR OFFICE
// //               </h2>
// //               <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed px-4">
// //                 Step into our studio and immerse yourself in refined design.
// // Witness how creativity and elegance shape every detail of your space
// //               </p>
// //             </div>
// //           </div>

// //           {/* Image with Floating Card */}
// //           <div data-animate id="office-image">
// //             <div className={`relative transition-all duration-1000 delay-300 ${isVisible['office-image'] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
// //               {/* Background Image */}
// //               <img
// //                 src="https://cdn.prod.website-files.com/66ec399f6b28eb713c5695e8/66f43197a22bf84004241060_our-office-image-decor-x-webflow-template.jpg"
// //                 alt="Modern Office Workspace"
// //                 className="w-full h-[400px] sm:h-[500px] md:h-[600px] object-cover"
// //               />

// //               {/* Floating Office Info Card */}
// //               <div className="absolute top-4 sm:top-8 md:top-12 left-4 sm:left-8 md:left-12 bg-white p-6 sm:p-8 md:p-10 shadow-xl max-w-xs sm:max-w-sm">
// //                 <h3
// //                   className="text-xl sm:text-2xl md:text-3xl font-light text-stone-900 mb-6 sm:mb-8 md:mb-10 tracking-wider"
// //                   style={{ fontFamily: "'Playfair Display', serif" }}
// //                 >
// //                   OFFICE
// //                 </h3>

// //                 <div className="space-y-6 sm:space-y-8 md:space-y-10">
// //                   {/* Hyderabad Office */}
// //                   <div>
// //                     <h4
// //                       className="text-lg sm:text-xl font-medium text-stone-900 mb-2 md:mb-3 tracking-wide"
// //                       style={{ fontFamily: "'Playfair Display', serif" }}
// //                     >
// //                       HYDERABAD
// //                     </h4>
// //                     <p className="text-sm md:text-base text-stone-600 leading-relaxed">
// //                      Mathrusree Nagar, Miyapur <br />
// //                       Hyderabad
// //                     </p>
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Follow Our Journey */}
// //       <section className="py-16 md:py-20 bg-[#f5f1eb]">
// //         <div data-animate id="social-section">
// //           <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['social-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //             <h2
// //               className="text-2xl sm:text-3xl md:text-4xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
// //               style={{ fontFamily: "'Playfair Display', serif" }}
// //             >
// //               Follow Our Journey
// //             </h2>
// //             <p className="text-stone-600 mb-8 md:mb-12 text-base md:text-lg leading-relaxed px-4">
// //               Stay inspired with our latest projects and design insights.
// //             </p>

// //             <div className="flex justify-center space-x-6 md:space-x-8">
// //               {[
// //                 { icon: <Instagram className="w-5 h-5 md:w-6 md:h-6" />, name: "Instagram" },
// //                 { icon: <Facebook className="w-5 h-5 md:w-6 md:h-6" />, name: "Facebook" },
// //                 { icon: <Twitter className="w-5 h-5 md:w-6 md:h-6" />, name: "Twitter" },
// //                 { icon: <Linkedin className="w-5 h-5 md:w-6 md:h-6" />, name: "LinkedIn" }
// //               ].map((social, index) => (
// //                 <a
// //                   key={index}
// //                   href="#"
// //                   className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
// //                   aria-label={social.name}
// //                 >
// //                   {social.icon}
// //                 </a>
// //               ))}
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Footer */}
// //       <footer className="bg-[#f5f1eb] text-stone-800 py-12 md:py-16 border-t border-stone-300">
// //         <div data-animate id="footer">
// //           <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['footer'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
// //             <div
// //               className="text-2xl md:text-3xl font-light mb-4 md:mb-6 tracking-wider"
// //               style={{ fontFamily: "'Playfair Display', serif" }}
// //             >
// //               CONSTRUCT INSIDES
// //             </div>
// //             <p className="text-stone-600 mb-6 md:mb-8 text-base md:text-lg">
// //               Crafting extraordinary spaces since 2020
// //             </p>
// //             <div className="text-stone-500 text-xs md:text-sm">
// //               © 2025 Construct Insides . All rights reserved.
// //             </div>
// //           </div>
// //         </div>
// //       </footer>
// //     </div>
// //   );
// // };

// // export default ContactPage;


// import React, { useState, useEffect, useRef } from 'react';
// import { Menu, X, Phone, Mail, MapPin, Clock, Send, ArrowRight, Instagram, Twitter, Facebook, Linkedin } from 'lucide-react';
// import flooring from './Images/DINING.webp';
// import image1 from './Images/LIVINGANDPOOJA.webp';
// import kitchen4 from './Images/CROCKERY_V1 (1).webp';
// import fullhouse from './Images/fullbedroom.JPG';
// import falseCeiling1 from './Images/MASTER BEDROOM _V1.webp';

// // Reusable RevealImage Component
// const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
//   const wrapperRef = useRef();
//   useEffect(() => {
//     const el = wrapperRef.current;
//     const observer = new IntersectionObserver(
//       entries => {
//         entries.forEach(entry => {
//           if (entry.isIntersecting) {
//             el.classList.add("revealed");
//             observer.unobserve(el);
//           }
//         });
//       },
//       { threshold: 0.3 }
//     );
//     if (el) observer.observe(el);
//     return () => {
//       if (el) observer.unobserve(el);
//     };
//   }, []);
  
//   return (
//     <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
//       <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
//       <div className="reveal-mask"></div>
//     </div>
//   );
// };

// const ContactPage = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [scrollY, setScrollY] = useState(0);
//   const [isVisible, setIsVisible] = useState({});
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     service: '',
//     message: ''
//   });

//   // Scroll handler for navbar background
//   useEffect(() => {
//     const handleScroll = () => setScrollY(window.scrollY);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);

//   // Intersection Observer for scroll animations
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(prev => ({
//               ...prev,
//               [entry.target.id]: true
//             }));
//           }
//         });
//       },
//       { 
//         threshold: 0.1,
//         rootMargin: '0px 0px -50px 0px'
//       }
//     );

//     const elements = document.querySelectorAll('[data-animate]');
//     elements.forEach((el) => observer.observe(el));

//     return () => observer.disconnect();
//   }, []);

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log('Form submitted:', formData);
//   };

//   const contactInfo = [
//     {
//       icon: <Phone className="w-5 h-5 md:w-6 md:h-6" />,
//       title: "Phone",
//       details: ["+91 95735 78899"],
//       action: "Call us today"
//     },
//     {
//       icon: <Mail className="w-5 h-5 md:w-6 md:h-6" />,
//       title: "Email",
//       details: ["support@constructinsides.com"],
//       action: "Send us a message"
//     },
//     {
//       icon: <MapPin className="w-5 h-5 md:w-6 md:h-6" />,
//       title: "Studio",
//       details: ["Mathrusree Nagar,", "Miyapur","HYDERABAD"],
//       action: "Visit our office"
//     },
//     {
//       icon: <Clock className="w-5 h-5 md:w-6 md:h-6" />,
//       title: "Hours",
//       details: ["Mon - Sat: 9AM - 7PM", "Sun: 10AM - 6PM"],
//       action: "Schedule appointment"
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
//       {/* Load Fonts */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
//         rel="stylesheet"
//       />

//       {/* Global CSS for smooth scrolling and hidden scrollbars */}
//       <style jsx global>{`
//         html {
//           scroll-behavior: smooth;
//         }
        
//         ::-webkit-scrollbar {
//           width: 0px;
//           background: transparent;
//         }
        
//         body {
//           scrollbar-width: none;
//           -ms-overflow-style: none;
//           overflow-x: hidden;
//         }
        
//         * {
//           -webkit-overflow-scrolling: touch;
//         }
//       `}</style>

//       {/* Reveal Animations */}
//       <style jsx>{`
//         /* RevealImage Effects */
//         .reveal-wrapper {
//           position: relative;
//           overflow: hidden;
//         }
        
//         .reveal-wrapper .reveal-mask {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: #f5f1eb;
//           transform: translateX(-100%);
//           transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//           z-index: 2;
//         }
        
//         .reveal-wrapper.revealed .reveal-mask {
//           transform: translateX(100%);
//         }
        
//         .reveal-wrapper img {
//           opacity: 0;
//           transform: scale(1.1);
//           transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .reveal-wrapper.revealed img {
//           opacity: 1;
//           transform: scale(1);
//         }

//         /* Fade animations */
//         .fade-up {
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
//         }
        
//         .fade-up.visible {
//           opacity: 1;
//           transform: translateY(0);
//         }
//       `}</style>

//       {/* Hero Section */}
//       <section className="bg-[#f5f1eb] py-16 sm:py-20 md:py-24 lg:py-32 relative">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
//             {/* Left Content */}
//             <div data-animate id="hero-content">
//               <div className={`flex flex-col justify-center h-full transition-all duration-1000 ${isVisible['hero-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//                 <h1
//                   className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-stone-800 mb-6 md:mb-8 leading-tight"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   ARE YOU READY FOR
//                   <br />
//                   YOUR NEW SPACE?
//                 </h1>

//                 <a
//                   href="#contact"
//                   className="inline-block text-base sm:text-lg font-medium tracking-wide text-stone-800 uppercase border-b border-stone-800 hover:text-stone-600 transition-colors w-fit"
//                 >
//                   Contact Us
//                 </a>
//               </div>
//             </div>

//             {/* Right Images */}
//             <div data-animate id="hero-images">
//               <div className={`relative transition-all duration-1000 delay-300 ${isVisible['hero-images'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
//                 {/* Main large image */}
//                 <div className="relative z-10">
//                   <RevealImage
//                     src={flooring}
//                     alt="Modern Kitchen Design"
//                     className="w-full max-w-[550px] h-[300px] sm:h-[350px] md:h-[420px]"
//                   />
//                 </div>

//                 {/* Overlapping smaller image */}
//                 <div className="absolute -bottom-10 sm:-bottom-16 md:-bottom-20 -left-4 sm:-left-8 md:-left-20 z-20 shadow-xl">
//                   <RevealImage
//                     src={image1}
//                     alt="Dining Area Design"
//                     className="w-[280px] sm:w-[320px] md:w-[380px] h-[180px] sm:h-[220px] md:h-[260px]"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Contact Information Section */}
//       <section className="py-16 md:py-20 bg-stone-50">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div data-animate id="contact-info-title">
//             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['contact-info-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2 
//                 className="text-3xl sm:text-4xl md:text-5xl font-bold text-stone-900 mb-4 md:mb-6"
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 Get In Touch
//               </h2>
//               <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto px-4">
//                 Multiple ways to reach us for your convenience. We're here to help bring your vision to life.
//               </p>
//             </div>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
//             {contactInfo.map((info, index) => (
//               <div key={index} data-animate id={`contact-card-${index}`}>
//                 <div
//                   className={`text-center group hover:transform hover:scale-105 transition-all duration-500 ${isVisible[`contact-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//                   style={{ transitionDelay: `${index * 100}ms` }}
//                 >
//                   <div className="bg-stone-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:bg-stone-200 transition-all duration-500">
//                     <div className="text-stone-700 group-hover:text-stone-900 transition-colors duration-500">
//                       {info.icon}
//                     </div>
//                   </div>
//                   <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-3 md:mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
//                     {info.title}
//                   </h3>
//                   <div className="space-y-1 md:space-y-2 mb-3 md:mb-4">
//                     {info.details.map((detail, idx) => (
//                       <p key={idx} className="text-sm md:text-base text-stone-600">{detail}</p>
//                     ))}
//                   </div>
//                   <p className="text-xs md:text-sm text-stone-500 font-medium">{info.action}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section className="py-16 md:py-20 bg-[#f5f1eb]" id="contact">
//         <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div data-animate id="form-title">
//             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['form-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2 
//                 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-stone-800 mb-4 md:mb-6 tracking-widest"
//                 style={{fontFamily: "'Playfair Display', serif"}}
//               >
//                 START YOUR PROJECT
//               </h2>
//               <p className="text-base md:text-lg text-stone-600 px-4 max-w-lg mx-auto leading-relaxed">
//                 Turn your vision into reality—start creating your dream interiors today
//               </p>
//             </div>
//           </div>

//           <div data-animate id="contact-form">
//             <div 
//               className={`space-y-6 md:space-y-8 transition-all duration-1000 delay-300 ${isVisible['contact-form'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//             >
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
//                 <div>
//                   <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
//                     Full Name*
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleInputChange}
//                     required
//                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
//                     placeholder="JOHN CARTER"
//                   />
//                 </div>
//                 <div>
//                   <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
//                     Phone Number*
//                   </label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleInputChange}
//                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
//                     placeholder=""
//                   />
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
//                   Email*
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={formData.email}
//                   onChange={handleInputChange}
//                   required
//                   className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
//                   placeholder="EXAMPLE@EMAIL.COM"
//                 />
//               </div>

//               <div>
//                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
//                   Service*
//                 </label>
//                 <div className="relative">
//                   <select
//                     name="service"
//                     value={formData.service}
//                     onChange={handleInputChange}
//                     className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 appearance-none cursor-pointer"
//                   >
//                     <option value="">EX. SPACE PLANNING</option>
//                     <option value="residential">RESIDENTIAL DESIGN</option>
//                     <option value="commercial">COMMERCIAL DESIGN</option>
//                     <option value="consultation">DESIGN CONSULTATION</option>
//                     <option value="renovation">FULL RENOVATION</option>
//                     <option value="styling">INTERIOR STYLING</option>
//                   </select>
//                   <div className="absolute right-0 top-1/2 transform -translate-y-1/2 pointer-events-none">
//                     <svg className="w-4 h-4 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                     </svg>
//                   </div>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
//                   Message
//                 </label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleInputChange}
//                   rows={5}
//                   className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 resize-none text-sm md:text-base text-stone-600 placeholder-stone-400"
//                   placeholder="WRITE YOUR MESSAGE"
//                 ></textarea>
//               </div>

//               <div className="pt-6">
//                 <div className="flex items-start space-x-3 mb-6">
//                   <input
//                     type="checkbox"
//                     id="privacy"
//                     className="mt-1 w-4 h-4 border border-stone-400 rounded-sm"
//                   />
//                   <label htmlFor="privacy" className="text-xs md:text-sm text-stone-600 leading-relaxed">
//                     By checking this box, you agree that your information is protected under our{' '}
//                     <span className="underline cursor-pointer">Privacy Policy</span> and our{' '}
//                     <span className="underline cursor-pointer">Terms and Conditions</span>.
//                   </label>
//                 </div>

//                 <button
//                   onClick={handleSubmit}
//                   className="bg-stone-900 text-stone-50 px-8 md:px-12 py-3 md:py-4 hover:bg-stone-800 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase"
//                   style={{fontFamily: "'Playfair Display', serif"}}
//                 >
//                   Send Message
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Visit Our Office Section */}
//       <section className="py-16 md:py-20 bg-[#f5f1eb]">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div data-animate id="office-title">
//             <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['office-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2
//                 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
//                 style={{ fontFamily: "'Playfair Display', serif" }}
//               >
//                 VISIT OUR OFFICE
//               </h2>
//               <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed px-4">
//                 Step into our studio and immerse yourself in refined design.
//                 Witness how creativity and elegance shape every detail of your space
//               </p>
//             </div>
//           </div>

//           <div data-animate id="office-image">
//             <div className={`relative transition-all duration-1000 delay-300 ${isVisible['office-image'] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
//               <RevealImage
//                 src={falseCeiling1}
//                 alt="Modern Office Workspace"
//                 className="w-full h-[400px] sm:h-[500px] md:h-[600px]"
//               />

//               {/* Floating Office Info Card */}
//               <div className="absolute top-4 sm:top-8 md:top-12 left-4 sm:left-8 md:left-12 bg-white p-6 sm:p-8 md:p-10 shadow-xl max-w-xs sm:max-w-sm">
//                 <h3
//                   className="text-xl sm:text-2xl md:text-3xl font-light text-stone-900 mb-6 sm:mb-8 md:mb-10 tracking-wider"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   OFFICE
//                 </h3>

//                 <div className="space-y-6 sm:space-y-8 md:space-y-10">
//                   <div>
//                     <h4
//                       className="text-lg sm:text-xl font-medium text-stone-900 mb-2 md:mb-3 tracking-wide"
//                       style={{ fontFamily: "'Playfair Display', serif" }}
//                     >
//                       HYDERABAD
//                     </h4>
//                     <p className="text-sm md:text-base text-stone-600 leading-relaxed">
//                       Mathrusree Nagar, Miyapur <br />
//                       Hyderabad
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Follow Our Journey */}
//       <section className="py-16 md:py-20 bg-[#f5f1eb]">
//         <div data-animate id="social-section">
//           <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['social-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//             <h2
//               className="text-2xl sm:text-3xl md:text-4xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
//               style={{ fontFamily: "'Playfair Display', serif" }}
//             >
//               Follow Our Journey
//             </h2>
//             <p className="text-stone-600 mb-8 md:mb-12 text-base md:text-lg leading-relaxed px-4">
//               Stay inspired with our latest projects and design insights.
//             </p>

//             <div className="flex justify-center space-x-6 md:space-x-8">
//               {[
//                 { icon: <Instagram className="w-5 h-5 md:w-6 md:h-6" />, name: "Instagram" },
//                 { icon: <Facebook className="w-5 h-5 md:w-6 md:h-6" />, name: "Facebook" },
//                 { icon: <Twitter className="w-5 h-5 md:w-6 md:h-6" />, name: "Twitter" },
//                 { icon: <Linkedin className="w-5 h-5 md:w-6 md:h-6" />, name: "LinkedIn" }
//               ].map((social, index) => (
//                 <a
//                   key={index}
//                   href="#"
//                   className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
//                   aria-label={social.name}
//                 >
//                   {social.icon}
//                 </a>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#f5f1eb] text-stone-800 py-12 md:py-16 border-t border-stone-300">
//         <div data-animate id="footer">
//           <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['footer'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//             <div
//               className="text-2xl md:text-3xl font-light mb-4 md:mb-6 tracking-wider"
//               style={{ fontFamily: "'Playfair Display', serif" }}
//             >
//               CONSTRUCT INSIDES
//             </div>
//             <p className="text-stone-600 mb-6 md:mb-8 text-base md:text-lg">
//               Crafting extraordinary spaces since 2020
//             </p>
//             <div className="text-stone-500 text-xs md:text-sm">
//               © 2025 Construct Insides. All rights reserved.
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ContactPage;

/**
 * EMAILJS SETUP INSTRUCTIONS:
 * 
 * 1. Sign up at https://www.emailjs.com/
 * 2. Add Email Service (Gmail/Outlook)
 * 3. Create Email Template with variables:
 *    {{from_name}}, {{from_email}}, {{phone}}, {{service}}, {{message}}
 * 4. Get Service ID, Template ID, and Public Key
 * 5. Install: npm install @emailjs/browser
 * 6. Replace the credentials below
 */

import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, Phone, Mail, MapPin, Clock, Send, ArrowRight, Instagram, Twitter, Facebook, Linkedin, CheckCircle, AlertCircle } from 'lucide-react';
import emailjs from '@emailjs/browser';
import flooring from './Images/DINING.webp';
import image1 from './Images/LIVINGANDPOOJA.webp';
import kitchen4 from './Images/CROCKERY_V1 (1).webp';
import fullhouse from './Images/fullbedroom.JPG';
import falseCeiling1 from './Images/MASTER BEDROOM _V1.webp';



// Reusable RevealImage Component
const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
  const wrapperRef = useRef();
  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add("revealed");
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
      <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
      <div className="reveal-mask"></div>
    </div>
  );
};

const ContactPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState({
    loading: false,
    success: false,
    error: false,
    message: ''
  });
  
  const formRef = useRef();

  // EmailJS Configuration - REPLACE WITH YOUR ACTUAL CREDENTIALS
  const EMAILJS_SERVICE_ID = 'service_cj8y6go'; 
  const EMAILJS_TEMPLATE_ID = 'template_av7r0i3'; 
  const EMAILJS_PUBLIC_KEY = 'Kdm9868L3B1qYCecz'; 

  // Scroll handler for navbar background
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({
              ...prev,
              [entry.target.id]: true
            }));
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.name || !formData.email || !formData.message) {
      setSubmitStatus({
        loading: false,
        success: false,
        error: true,
        message: 'Please fill in all required fields'
      });
      return;
    }

    setSubmitStatus({
      loading: true,
      success: false,
      error: false,
      message: ''
    });

    try {
      // Send email using EmailJS
      const result = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          phone: formData.phone,
          service: formData.service,
          message: formData.message,
          to_name: 'Construct Insides Team',
        },
        EMAILJS_PUBLIC_KEY
      );

      console.log('Email sent successfully:', result);
      
      // Success state
      setSubmitStatus({
        loading: false,
        success: true,
        error: false,
        message: 'Thank you! Your message has been sent successfully. We\'ll get back to you within 24 hours.'
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });

      // Clear success message after 5 seconds
      setTimeout(() => {
        setSubmitStatus({
          loading: false,
          success: false,
          error: false,
          message: ''
        });
      }, 5000);

    } catch (error) {
      console.error('EmailJS Error:', error);
      
      setSubmitStatus({
        loading: false,
        success: false,
        error: true,
        message: 'Oops! Something went wrong. Please try again or contact us directly at support@constructinsides.com'
      });

      // Clear error message after 5 seconds
      setTimeout(() => {
        setSubmitStatus({
          loading: false,
          success: false,
          error: false,
          message: ''
        });
      }, 5000);
    }
  };

  const contactInfo = [
    {
      icon: <Phone className="w-5 h-5 md:w-6 md:h-6" />,
      title: "Phone",
      details: ["+91 95735 78899"],
      action: "Call us today"
    },
    {
      icon: <Mail className="w-5 h-5 md:w-6 md:h-6" />,
      title: "Email",
      details: ["Constructinsides@gmail.com"],
      action: "Send us a message"
    },
    {
      icon: <MapPin className="w-5 h-5 md:w-6 md:h-6" />,
      title: "Studio",
      details: ["Mathrusree Nagar,", "Miyapur","HYDERABAD"],
      action: "Visit our office"
    },
    {
      icon: <Clock className="w-5 h-5 md:w-6 md:h-6" />,
      title: "Hours",
      details: ["Mon - Sat: 9AM - 7PM", "Sun: 10AM - 6PM"],
      action: "Schedule appointment"
    }
  ];

  return (
    <div className="min-h-screen bg-stone-50 text-stone-800 overflow-x-hidden">
      {/* Load Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      {/* Global CSS */}
      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        
        ::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
        
        body {
          scrollbar-width: none;
          -ms-overflow-style: none;
          overflow-x: hidden;
        }
        
        * {
          -webkit-overflow-scrolling: touch;
        }
      `}</style>

      {/* Reveal Animations */}
      <style jsx>{`
        .reveal-wrapper {
          position: relative;
          overflow: hidden;
        }
        
        .reveal-wrapper .reveal-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #f5f1eb;
          transform: translateX(-100%);
          transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          z-index: 2;
        }
        
        .reveal-wrapper.revealed .reveal-mask {
          transform: translateX(100%);
        }
        
        .reveal-wrapper img {
          opacity: 0;
          transform: scale(1.1);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .reveal-wrapper.revealed img {
          opacity: 1;
          transform: scale(1);
        }

        .fade-up {
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .fade-up.visible {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>

      {/* Hero Section */}
      <section className="bg-[#f5f1eb] py-16 sm:py-20 md:py-24 lg:py-32 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Left Content */}
            <div data-animate id="hero-content">
              <div className={`flex flex-col justify-center h-full transition-all duration-1000 ${isVisible['hero-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <h1
                  className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light text-stone-800 mb-6 md:mb-8 leading-tight"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  ARE YOU READY FOR
                  <br />
                  YOUR NEW SPACE?
                </h1>

                <a
                  href="#contact"
                  className="inline-block text-base sm:text-lg font-medium tracking-wide text-stone-800 uppercase border-b border-stone-800 hover:text-stone-600 transition-colors w-fit"
                >
                  Contact Us
                </a>
              </div>
            </div>

            {/* Right Images */}
            <div data-animate id="hero-images">
              <div className={`relative transition-all duration-1000 delay-300 ${isVisible['hero-images'] ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}>
                <div className="relative z-10">
                  <RevealImage
                    src={flooring}
                    alt="Modern Kitchen Design"
                    className="w-full max-w-[550px] h-[300px] sm:h-[350px] md:h-[420px]"
                  />
                </div>

                <div className="absolute -bottom-10 sm:-bottom-16 md:-bottom-20 -left-4 sm:-left-8 md:-left-20 z-20 shadow-xl">
                  <RevealImage
                    src={image1}
                    alt="Dining Area Design"
                    className="w-[280px] sm:w-[320px] md:w-[380px] h-[180px] sm:h-[220px] md:h-[260px]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-16 md:py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-animate id="contact-info-title">
            <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['contact-info-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 
                className="text-3xl sm:text-4xl md:text-5xl font-bold text-stone-900 mb-4 md:mb-6"
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                Get In Touch
              </h2>
              <p className="text-lg md:text-xl text-stone-600 max-w-3xl mx-auto px-4">
                Multiple ways to reach us for your convenience. We're here to help bring your vision to life.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {contactInfo.map((info, index) => (
              <div key={index} data-animate id={`contact-card-${index}`}>
                <div
                  className={`text-center group hover:transform hover:scale-105 transition-all duration-500 ${isVisible[`contact-card-${index}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className="bg-stone-100 w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 group-hover:bg-stone-200 transition-all duration-500">
                    <div className="text-stone-700 group-hover:text-stone-900 transition-colors duration-500">
                      {info.icon}
                    </div>
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-stone-900 mb-3 md:mb-4" style={{fontFamily: "'Playfair Display', serif"}}>
                    {info.title}
                  </h3>
                  <div className="space-y-1 md:space-y-2 mb-3 md:mb-4">
                    {info.details.map((detail, idx) => (
                      <p key={idx} className="text-sm md:text-base text-stone-600">{detail}</p>
                    ))}
                  </div>
                  <p className="text-xs md:text-sm text-stone-500 font-medium">{info.action}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="py-16 md:py-20 bg-[#f5f1eb]" id="contact">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-animate id="form-title">
            <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['form-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 
                className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-stone-800 mb-4 md:mb-6 tracking-widest"
                style={{fontFamily: "'Playfair Display', serif"}}
              >
                START YOUR PROJECT
              </h2>
              <p className="text-base md:text-lg text-stone-600 px-4 max-w-lg mx-auto leading-relaxed">
                Turn your vision into reality—start creating your dream interiors today
              </p>
            </div>
          </div>

          <div data-animate id="contact-form">
            <div 
              ref={formRef}
              className={`space-y-6 md:space-y-8 transition-all duration-1000 delay-300 ${isVisible['contact-form'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                <div>
                  <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
                    Full Name*
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
                    placeholder="JOHN CARTER"
                  />
                </div>
                <div>
                  <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>
              </div>

              <div>
                <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
                  Email*
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 placeholder-stone-400"
                  placeholder="EXAMPLE@EMAIL.COM"
                />
              </div>

              <div>
                <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
                  Service
                </label>
                <div className="relative">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 text-sm md:text-base text-stone-600 appearance-none cursor-pointer"
                  >
                    <option value="">EX. SPACE PLANNING</option>
                    <option value="residential">RESIDENTIAL DESIGN</option>
                    <option value="commercial">COMMERCIAL DESIGN</option>
                    <option value="consultation">DESIGN CONSULTATION</option>
                    <option value="renovation">FULL RENOVATION</option>
                    <option value="styling">INTERIOR STYLING</option>
                  </select>
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 pointer-events-none">
                    <svg className="w-4 h-4 text-stone-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-stone-800 font-light mb-2 md:mb-3 text-sm md:text-base tracking-wider uppercase" style={{fontFamily: "'Playfair Display', serif"}}>
                  Message*
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                  rows={5}
                  className="w-full px-0 py-3 md:py-4 bg-transparent border-0 border-b border-stone-400 focus:outline-none focus:border-stone-800 transition-all duration-300 resize-none text-sm md:text-base text-stone-600 placeholder-stone-400"
                  placeholder="WRITE YOUR MESSAGE"
                ></textarea>
              </div>

              <div className="pt-6">
                <div className="flex items-start space-x-3 mb-6">
                  <input
                    type="checkbox"
                    id="privacy"
                    className="mt-1 w-4 h-4 border border-stone-400 rounded-sm"
                  />
                  <label htmlFor="privacy" className="text-xs md:text-sm text-stone-600 leading-relaxed">
                    By checking this box, you agree that your information is protected under our{' '}
                    <span className="underline cursor-pointer">Privacy Policy</span> and our{' '}
                    <span className="underline cursor-pointer">Terms and Conditions</span>.
                  </label>
                </div>

                {/* Status Messages */}
                {submitStatus.message && (
                  <div className={`mb-6 p-4 rounded-lg flex items-start gap-3 ${
                    submitStatus.success 
                      ? 'bg-green-50 border border-green-200' 
                      : submitStatus.error 
                      ? 'bg-red-50 border border-red-200' 
                      : ''
                  }`}>
                    {submitStatus.success && (
                      <CheckCircle className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    )}
                    {submitStatus.error && (
                      <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    )}
                    <p className={`text-sm ${
                      submitStatus.success 
                        ? 'text-green-800' 
                        : submitStatus.error 
                        ? 'text-red-800' 
                        : ''
                    }`}>
                      {submitStatus.message}
                    </p>
                  </div>
                )}

                <button
                  type="button"
                  onClick={handleSubmit}
                  disabled={submitStatus.loading}
                  className={`bg-stone-900 text-stone-50 px-8 md:px-12 py-3 md:py-4 hover:bg-stone-800 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase ${
                    submitStatus.loading ? 'opacity-70 cursor-not-allowed' : ''
                  }`}
                  style={{fontFamily: "'Playfair Display', serif"}}
                >
                  {submitStatus.loading ? (
                    <span className="flex items-center gap-2 justify-center">
                      <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Sending...
                    </span>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visit Our Office Section */}
      <section className="py-16 md:py-20 bg-[#f5f1eb]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-animate id="office-title">
            <div className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${isVisible['office-title'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                VISIT OUR OFFICE
              </h2>
              <p className="text-base md:text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed px-4">
                Step into our studio and immerse yourself in refined design.
                Witness how creativity and elegance shape every detail of your space
              </p>
            </div>
          </div>

          <div data-animate id="office-image">
            <div className={`relative transition-all duration-1000 delay-300 ${isVisible['office-image'] ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
              <RevealImage
                src={falseCeiling1}
                alt="Modern Office Workspace"
                className="w-full h-[400px] sm:h-[500px] md:h-[600px]"
              />

              {/* Floating Office Info Card */}
              <div className="absolute top-4 sm:top-8 md:top-12 left-4 sm:left-8 md:left-12 bg-white p-6 sm:p-8 md:p-10 shadow-xl max-w-xs sm:max-w-sm">
                <h3
                  className="text-xl sm:text-2xl md:text-3xl font-light text-stone-900 mb-6 sm:mb-8 md:mb-10 tracking-wider"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  OFFICE
                </h3>

                <div className="space-y-6 sm:space-y-8 md:space-y-10">
                  <div>
                    <h4
                      className="text-lg sm:text-xl font-medium text-stone-900 mb-2 md:mb-3 tracking-wide"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      HYDERABAD
                    </h4>
                    <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                      Mathrusree Nagar, Miyapur <br />
                      Hyderabad
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Follow Our Journey */}
      {/* <section className="py-16 md:py-20 bg-[#f5f1eb]">
        <div data-animate id="social-section">
          <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['social-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Follow Our Journey
            </h2>
            <p className="text-stone-600 mb-8 md:mb-12 text-base md:text-lg leading-relaxed px-4">
              Stay inspired with our latest projects and design insights.
            </p>

            <div className="flex justify-center space-x-6 md:space-x-8">
              {[
                { icon: <Instagram className="w-5 h-5 md:w-6 md:h-6" />, name: "Instagram" },
                { icon: <Facebook className="w-5 h-5 md:w-6 md:h-6" />, name: "Facebook" },
                { icon: <Twitter className="w-5 h-5 md:w-6 md:h-6" />, name: "Twitter" },
                { icon: <Linkedin className="w-5 h-5 md:w-6 md:h-6" />, name: "LinkedIn" }
              ].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section> */}
      <section className="py-16 md:py-20 bg-[#f5f1eb]">
  <div data-animate id="social-section">
    <div
      className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${
        isVisible['social-section']
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-10'
      }`}
    >
      <h2
        className="text-2xl sm:text-3xl md:text-4xl font-light text-stone-800 mb-4 md:mb-6 tracking-wider"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Follow Our Journey
      </h2>
      <p className="text-stone-600 mb-8 md:mb-12 text-base md:text-lg leading-relaxed px-4">
        Stay inspired with our latest projects and design insights.
      </p>

      <div className="flex justify-center space-x-6 md:space-x-8">
        {/* Instagram */}
        <a
          href="https://www.instagram.com/constructinsides/?hl=en"
          target="_blank"
          rel="noopener noreferrer"
          className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
          aria-label="Instagram"
        >
          <Instagram className="w-5 h-5 md:w-6 md:h-6" />
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/constructinsides.in"
          target="_blank"
          rel="noopener noreferrer"
          className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
          aria-label="Facebook"
        >
          <Facebook className="w-5 h-5 md:w-6 md:h-6" />
        </a>

        {/* Twitter */}
        {/* <a
          href="https://twitter.com/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
          aria-label="Twitter"
        >
          <Twitter className="w-5 h-5 md:w-6 md:h-6" />
        </a> */}

        {/* LinkedIn */}
        {/* <a
          href="https://www.linkedin.com/in/yourprofile"
          target="_blank"
          rel="noopener noreferrer"
          className="text-stone-700 hover:text-stone-900 transition-colors duration-300 p-2"
          aria-label="LinkedIn"
        >
          <Linkedin className="w-5 h-5 md:w-6 md:h-6" />
        </a> */}
      </div>
    </div>
  </div>
</section>


      {/* Footer */}
      <footer className="bg-[#f5f1eb] text-stone-800 py-12 md:py-16 border-t border-stone-300">
        <div data-animate id="footer">
          <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['footer'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div
              className="text-2xl md:text-3xl font-light mb-4 md:mb-6 tracking-wider"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              CONSTRUCT INSIDES
            </div>
            <p className="text-stone-600 mb-6 md:mb-8 text-base md:text-lg">
              Crafting extraordinary spaces since 2020
            </p>
            <div className="text-stone-500 text-xs md:text-sm">
              © 2025 Construct Insides. All rights reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;